import React, { useRef } from "react"
import { connect } from "react-redux"

import {
  useDisclosure,
  Flex,
  Box,
  Switch,
  FormControl,
  FormLabel,
  Button,
  AlertDialog,
  AlertDialogCloseButton,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react"

import {
  resetProject,
  resetSheet,
  isSlimOnUpdate,
  isDetailsOnUpdate,
} from "../../redux/actions/project"

const SwitchDetails = ({ params, dispatch }) => {
  //=================================================================
  const {
    isOpen: isOpenProject,
    onOpen: onOpenProject,
    onClose: onCloseProject,
  } = useDisclosure()

  const {
    isOpen: isOpenSheet,
    onOpen: onOpenSheet,
    onClose: onCloseSheet,
  } = useDisclosure()

  const cancelRefProject = useRef()
  const cancelRefSheet = useRef()

  const { isSlimOn, isDetailsOn } = params

  //-----------------------------------------------------------------

  const onClickResetProject = () => {
    dispatch(resetProject())
    onCloseProject()
  }

  const onClickResetSheet = () => {
    dispatch(resetSheet())
    onCloseSheet()
  }

  const onChangeSlim = (e) => {
    dispatch(isSlimOnUpdate())
  }

  const onChangeDetails = (e) => {
    dispatch(isDetailsOnUpdate())
  }

  //=================================================================
  return (
    <>
      <Flex>
        <Button
          onClick={onOpenProject}
          color="white"
          bg="blue.800"
          borderRadius="5px"
          mb={2}
        >
          Reset Project
        </Button>
        <Button
          onClick={onOpenSheet}
          color="white"
          bg="blue.800"
          borderRadius="5px"
          ml={1}
          mb={2}
        >
          Reset Sheet
        </Button>
        <Box mt="1px" display="none" mx={2}>
          <FormControl display="flex" alignItems="center">
            <FormLabel htmlFor="isDetailsOn" color="blue.900" mb="0">
              Slim
            </FormLabel>
            <Switch
              id="isDetailsOn"
              onChange={onChangeSlim}
              isChecked={isSlimOn}
              colorScheme="blue800"
            />
          </FormControl>
        </Box>
        <Box mt="1px">
          <FormControl display="flex" alignItems="center">
            <FormLabel htmlFor="isDetailsOn" color="blue.900" mb="0">
              Details
            </FormLabel>
            <Switch
              id="isDetailsOn"
              onChange={onChangeDetails}
              isChecked={isDetailsOn}
              colorScheme="blue800"
            />
          </FormControl>
        </Box>
      </Flex>

      <AlertDialog
        leastDestructiveRef={cancelRefProject}
        onClose={onCloseProject}
        isOpen={isOpenProject}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Confirm Reset Project?</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            Are you sure you want to reset your whole project? All your
            deliverables and all persons will be deleted.
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRefProject} onClick={onCloseProject}>
              Cancel
            </Button>
            <Button color="white" bg="red" ml={3} onClick={onClickResetProject}>
              Reset
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog
        leastDestructiveRef={cancelRefSheet}
        onClose={onCloseSheet}
        isOpen={isOpenSheet}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Confirm Reset Sheet?</AlertDialogHeader>

          <AlertDialogBody>
            Are you sure you want to reset your sheet? Persons and general
            project parameters will be kept, but all your deliverables will be
            deleted.
          </AlertDialogBody>
          <AlertDialogCloseButton />

          <AlertDialogFooter>
            <Button ref={cancelRefSheet} onClick={onCloseSheet}>
              Cancel
            </Button>
            <Button color="white" bg="red" ml={3} onClick={onClickResetSheet}>
              Reset
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    params: state.project.params,
  }
}

export default connect(mapStateToProps)(SwitchDetails)
